import { DateFormatPreset, formatDate } from '@procureai/ui-mui';

import { ResponsiveTableCell } from '../ResponsiveTable.types';

type DateCellOptions = {
  preset: DateFormatPreset;
  fallback?: string;
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const DateCellFactory = <D extends {} = {}>(options: DateCellOptions) => {
  const formatValue = formatDate(options.preset);

  const DateCell: ResponsiveTableCell<D> = ({ value }) => {
    return <>{value ? formatValue(new Date(value)) : options.fallback}</>;
  };
  return DateCell;
};
